import gql from 'graphql-tag';
const LEFT_IMAGE_PARAGRAPH_ACTIVITY_FRAGMENT = gql `
  fragment LeftImageParagraphActivityFragment on LeftImageParagraphActivity {
    rounds {
      id
      title
      textSize
      contentImage {
        id
        image {
          description
          id
          src
        }
      }
      steps {
        id
        answer
      }
    }
  }
`;
export default LEFT_IMAGE_PARAGRAPH_ACTIVITY_FRAGMENT;
